import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const MySpacePage = loadable(() => import('./MySpacePage'));
export default {
    id: 'my_space',
    title: 'My Space',
    icon: 'book',
    route: 'my-space',
    defaultRoute: 'my-space/news',
    hasDynamicDefaultRoute: true,
    group: 'administration',
    component: MySpacePage,
    order: 9,
    isPermissionCheckSkipped: true,
    panelExtensions: [],
    hasQuickLinkButton: true,
    structure,
};
